// Client portal menu items exposed as permission modules.
export const CLIENT_MENU_MODULES = [
  { title: 'Live Report', module: 'CLIENT LIVE REPORT', level: 0 },
  { title: 'Daily Report', module: 'CLIENT DAILY REPORT', level: 0 },
  { title: 'Permit Applications', module: 'CLIENT PERMIT APPLICATIONS', level: 0 },
  { title: 'Required Permit Search', module: 'CLIENT PERMIT SEARCH', level: 0 },
  { title: 'TMDA Permit Application', module: 'CLIENT TMDA APPLICATION', level: 0 },
];
